import { Typography } from '@design-system/components/typography/typography';
import { Tab, Tabs } from '@mui/material';
import { OtpBundlesVMData } from '../viewModel/otpBundles.viewModel';
import { Button } from '@design-system/components/button/button';
import { OtpBundleCard } from './OtpBundleCard';
import { BundleForm } from './BundleForm';
import { OtpBundleEmptyState } from './EmptyStateCard';
import { sprinkles } from '@design-system/sprinkles.css';
import { LinksModal } from './LinksModal';
import { ConfirmDeleteModal } from './ConfirmDeleteModal';
import { ConfirmArchiveModal } from './ConfirmArchiveModal';
import { ConfirmPublishModal } from '../../common/ConfirmPublishModal';
import { ConfirmUnsavedChangesModal } from './ConfirmUnsavedChangesModal';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';

export const OtpBundles = ({
  add,
  formData,
  list,
  emptyState,
  linksModal,
  deleteModal,
  archiveModal,
  publishModal,
  unsavedChangesModal,
}: OtpBundlesVMData) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <Typography variant="body" size="medium" color="N-80" fontWeight="bold">
          One-Time Purchase Offers
        </Typography>
        <Button
          variant="filled"
          size="large"
          color="neutral"
          onClick={() => add()}
          leftIcon={faPlus}
        >
          Create
        </Button>
      </div>
      {emptyState.show ? (
        <OtpBundleEmptyState {...emptyState} />
      ) : (
        <OtpBundlesList {...list} />
      )}
      <BundleForm {...formData} />
      <LinksModal {...linksModal} />
      <ConfirmDeleteModal {...deleteModal} />
      <ConfirmArchiveModal {...archiveModal} />
      <ConfirmPublishModal {...publishModal} />
      <ConfirmUnsavedChangesModal {...unsavedChangesModal} />
    </div>
  );
};

const OtpBundlesList = ({
  activeTab,
  changeTab,
  items,
  filterTabs,
}: OtpBundlesVMData['list']) => {
  return (
    <div className="flex flex-col gap-4">
      <Tabs
        value={activeTab}
        onChange={(ev, value: string) => changeTab(value)}
      >
        {filterTabs.map(({ label, value, badge }) => (
          <Tab
            key={value}
            value={value}
            label={<TabLabel label={label} badge={badge} />}
            iconPosition="start"
            style={{
              fontWeight: 500,
              fontSize: '14px',
              fontFamily: 'Visuelt',
              lineHeight: '20px',
              color: 'black',
            }}
          />
        ))}
      </Tabs>
      <div className="flex gap-4 flex-wrap">
        {items.map((item, index) => (
          <OtpBundleCard key={index} {...item} />
        ))}
      </div>
    </div>
  );
};

const TabLabel = ({ label, badge }: { label: string; badge: number }) => {
  if (badge === 0)
    return (
      <Typography variant="body" size="medium">
        {label}
      </Typography>
    );

  return (
    <div className="flex gap-2 items-center">
      <Typography variant="body" size="medium">
        {label}
      </Typography>
      <div
        className={sprinkles({
          bg: 'N-20',
          px: 'm',
          py: 's',
          borderRadius: 'l',
        })}
      >
        {badge}
      </div>
    </div>
  );
};
